/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import classnames from 'classnames';
import {dlsColor} from '../../theme/theme';
import styles from './IonSpinner.module.scss';

export interface IonSpinnerTypes {
  width?: string;
  height?: string;
};

const useStyles = makeStyles(theme => ({
  circle1 : {
    '&::before' : {
      background : `${dlsColor('aquaBlue')} !important`
    }
  },
  circle2 : {
    '&::before' : {
      background : `${dlsColor('tealBlue')} !important`
    }
  },
  circle3 : {
    '&::before' : {
      background : `${dlsColor('frostBlue')} !important`
    }
  }
}));

/**
 * @IonSpinner
 *
 * Pulsing spinner component per the DLS
 *
 * ```typescript
 *
 *   <IonSpinner />
 *   <IonSpinner width='60px' height='60px' />
 *
 * ```
 */
export const IonSpinner = ({width = '45px', height = '45px'}: IonSpinnerTypes) => {
  const classes = useStyles();
  return (
    <div className={styles.spinner} style={{width, height}}>
      <div className={classnames(styles.circle, styles.circle1, classes.circle1)} />
      <div className={classnames(styles.circle, styles.circle2, classes.circle2)} />
      <div className={classnames(styles.circle, styles.circle3, classes.circle3)} />
    </div>
  );
};

export default IonSpinner;
